import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import WhatIsSection from "./components/WhatIsSection";
import WhySection from "./components/WhySection";
import CategoryGrid from "./components/CategoryGrid";
import HowItWorks from "./components/HowItWorks";
import ComparisonTable from "./components/ComparisonTable";
import SafetySection from "./components/SafetySection";
import ArticleGrid from "./components/ArticleGrid";
import ArticleCTA from "./components/ArticleCTA";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <WhatIsSection />
      <WhySection />
      <CategoryGrid />
      <HowItWorks />
      <ComparisonTable />
      <SafetySection />
      <ArticleGrid />
      <ArticleCTA />
      <Newsletter />
      <Footer />
    </main>
  );
}